<div class="main-content">
  <h1 mat-dialog-title>Of: {{ instance?.NumOf }}</h1>
  <form [formGroup]="instanceForm">
    <table class="cim-full-width" cellspacing="0">
      <tr>
        <td width="30%">
          <mat-form-field class="cim-full-width">
            <mat-label>Article</mat-label>
            <input
              matInput
              type="text"
              placeholder="Article"
              formControlName="Article"
            />
          </mat-form-field>
        </td>
        <td>
          <mat-form-field class="cim-full-width">
            <mat-label>Description</mat-label>
            <input
              matInput
              type="text"
              placeholder="Description"
              formControlName="DescCourteArticle"
            />
          </mat-form-field>
        </td>
      </tr>
    </table>
    <table class="cim-full-width" cellspacing="0">
      <tr>
        <td>
          <mat-form-field class="cim-full-width">
            <mat-label>Qté UP</mat-label>
            <input
              matInput
              type="text"
              placeholder="Qté UP"
              formControlName="QteLancee"
            />
          </mat-form-field>
        </td>
        <td>
          <mat-form-field class="cim-full-width">
            <mat-label>Type Origine</mat-label>
            <input
              matInput
              type="text"
              placeholder="Type Origine"
              formControlName="TypeOrigine"
            />
          </mat-form-field>
        </td>
      </tr>
    </table>
    <table class="cim-full-width" cellspacing="0">
      <tr>
        <td width="25%">
          <mat-form-field class="cim-full-width">
            <mat-label>Statut</mat-label>
            <input
              matInput
              [value]="instanceForm.get('StatutOf').value | statutOperOf"
              type="text"
              placeholder="Statut"
              formControlName="StatutOf"
            />
          </mat-form-field>
        </td>
        <td width="25%">
          <mat-form-field class="cim-full-width">
            <mat-label>Num Client</mat-label>
            <input
              matInput
              type="text"
              placeholder="Num Client"
              formControlName="NumClient"
            />
          </mat-form-field>
        </td>
        <td width="25%">
          <mat-form-field class="cim-full-width">
            <mat-label>Num Cde Client</mat-label>
            <input
              matInput
              type="text"
              placeholder="Num Cde Client"
              formControlName="NumCdeCli"
            />
          </mat-form-field>
        </td>
        <td width="25%">
          <mat-form-field class="cim-full-width">
            <mat-label>N° Chrono Cde</mat-label>
            <input
              matInput
              type="text"
              placeholder="N° Chrono Cde"
              formControlName="NumeroCde"
            />
          </mat-form-field>
        </td>
      </tr>
    </table>
    <table class="cim-full-width" cellspacing="0">
      <tr>
        <td>
          <mat-form-field class="cim-full-width">
            <mat-label>Date Début Tôt</mat-label>
            <input
              matInput
              type="datetime-local"
              placeholder="Date Début Tôt"
              formControlName="DateDebutTot"
            />
          </mat-form-field>
        </td>
        <td>
          <mat-form-field class="cim-full-width">
            <mat-label>Date Fin Tard</mat-label>
            <input
              matInput
              type="datetime-local"
              placeholder="Date Fin Tard"
              formControlName="DateFinTard"
            />
          </mat-form-field>
        </td>
        <td>
          <mat-form-field class="cim-full-width">
            <mat-label>Date Début Prev</mat-label>
            <input
              matInput
              type="datetime-local"
              placeholder="Date Début Prev"
              formControlName="DateDebutPrev"
            />
          </mat-form-field>
        </td>
        <td>
          <mat-form-field class="cim-full-width">
            <mat-label>Règle Jalon</mat-label>
            <input
              matInput
              type="text"
              placeholder="Règle Jalon"
              formControlName="RegleJalon"
            />
          </mat-form-field>
        </td>
      </tr>
    </table>
    <div>
      <mat-form-field class="cim-full-width">
        <mat-label>Consignes Fab</mat-label>
        <textarea
          matInput
          type="textarea"
          placeholder="Consignes Fab"
          formControlName="ConsignesFab"
        ></textarea>
      </mat-form-field>
    </div>
    <table class="cim-full-width" cellspacing="0">
      <tr>
        <td>
          <mat-checkbox
            formControlName="NonJalonnable"
            (change)="updateTask('NonJalonnable')"
            >Non Jalonnable</mat-checkbox
          >
        </td>
        <td>
          <mat-checkbox
            formControlName="Interrompu"
            (change)="updateTask('Interrompu')"
            >Interrompu</mat-checkbox
          >
        </td>
        <td>
          <mat-form-field class="cim-full-width">
            <mat-label>Priorité</mat-label>
            <input
              matInput
              type="text"
              placeholder="Priorité"
              formControlName="Priorite"
              (change)="updateTask('Priorite')"
            />
          </mat-form-field>
        </td>
      </tr>
    </table>
    <table class="cim-full-width" cellspacing="0">
      <tr>
        <td>
          <mat-checkbox #ratio [checked]="true" formControlName="Ratio"
            >Préserver le ratio</mat-checkbox
          >
        </td>
      </tr>
    </table>
    <table class="cim-full-width" cellspacing="0">
      <tr>
        <td>
          <mat-form-field class="cim-full-width">
            <mat-label>Date début jalon</mat-label>
            <input
              matInput
              [matDatepicker]="picker"
              #dateDebutJalon
              placeholder="Date début jalon"
              [value]="data.task.start_date"
              (dateChange)="dateHasChanged('start', $event, ratio.checked)"
              [disabled]="!isMovable()"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </td>
        <td>
          <ngx-timepicker-field
            [format]="24"
            #timeDebutJalon
            [disabled]="!isMovable()"
          ></ngx-timepicker-field>
        </td>
        <td>
          <mat-form-field class="cim-full-width">
            <mat-label>Date fin jalon</mat-label>
            <input
              matInput
              [matDatepicker]="picker2"
              placeholder="Date fin jalon"
              [value]="data.task.end_date"
              (dateChange)="dateHasChanged('end', $event, ratio.checked)"
              [disabled]="!isMovable()"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker2"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
          </mat-form-field>
        </td>
        <td>
          <ngx-timepicker-field
            [format]="24"
            #timeFinJalon
            [disabled]="!isMovable()"
          ></ngx-timepicker-field>
        </td>
      </tr>
    </table>
    <div mat-dialog-actions>
      <button
        mat-raised-button
        (click)="close()"
        cdkFocusInitial
        class="mat-raised-button mat-primary"
      >
        Ok
      </button>
      <button
        mat-raised-button
        [mat-dialog-close]="false"
        cdkFocusInitial
        class="mat-raised-button mat-warn"
      >
        Cancel
      </button>
    </div>
  </form>
</div>
